import { zip } from 'fflate';

const urlPdf = process.env.NODE_ENV === 'production'
  ? 'https://sideop-generador-pdf.hermosillo.gob.mx/crear' : 'http://localhost:3991/crear';

export const nombreArchivoReporte = (contrato, reporte) => `${(contrato && contrato.numero) || 'Contrato'}_Reporte_fisico_${reporte.numero}`
  .replace(/[^a-zA-Z0-9_.-]/g, '_');

export function leerBlob(blob) {
  return new Promise((resolve, reject) => {
    const lector = new FileReader();
    lector.onload = () => resolve(new Uint8Array(lector.result));
    lector.onerror = () => reject(new Error('No se pudo leer el archivo generado.'));
    lector.readAsArrayBuffer(blob);
  });
}

export async function generarPdfReporte(axios, documento, cancelToken) {
  const respuesta = await axios.post(urlPdf, {
    configuracion: {
      nombreTemplate: 'templateReporteFisico',
      PUPPETEER_CONFIGURACION: {
        format: 'Letter',
        landscape: false,
        printBackground: true,
        preferCSSPageSize: true,
        displayHeaderFooter: false,
      },
    },
    data: { documento },
  }, { responseType: 'blob', timeout: 300000, ...(cancelToken ? { cancelToken } : {}) });
  if (!respuesta.data || !respuesta.data.size) throw new Error('Respuesta PDF vacía');
  const cabecera = await leerBlob(respuesta.data.slice(0, 5));
  if (Array.from(cabecera).join(',') !== '37,80,68,70,45') {
    throw new Error('El generador no devolvió un PDF válido.');
  }
  return respuesta.data;
}

export async function crearZipReportes(archivos) {
  if (!archivos.length) throw new Error('No hay archivos PDF para descargar.');
  const entradas = Object.create(null);
  // Los PDF ya están comprimidos; almacenarlos evita volver a comprimirlos.
  // eslint-disable-next-line no-restricted-syntax
  for (const archivo of archivos) {
    // eslint-disable-next-line no-await-in-loop
    entradas[archivo.nombre] = await leerBlob(archivo.pdf);
  }
  return new Promise((resolve, reject) => {
    zip(entradas, { level: 0 }, (error, contenido) => {
      if (error) reject(error);
      else resolve(new Blob([contenido], { type: 'application/zip' }));
    });
  });
}
